import { useState, useRef, useCallback } from "react";
import EasingPicker from "./EasingPicker";

const PX_PER_SEC = 80;

export default function Keyframe({ kf, onMove, onDelete, onEasingChange, trackRef, onDragStart, onDragEnd }) {
  const [showEasing, setShowEasing] = useState(false);
  const draggingRef = useRef(false);

  const handleMouseDown = useCallback(
    (e) => {
      e.stopPropagation();
      draggingRef.current = true;
      onDragStart?.();

      const onMouseMove = (moveEvent) => {
        if (!draggingRef.current || !trackRef.current) return;
        const rect = trackRef.current.getBoundingClientRect();
        const x = moveEvent.clientX - rect.left;
        const newTime = Math.max(0, x / PX_PER_SEC);
        onMove(Math.round(newTime * 20) / 20); // snap ke 0.05s
      };

      const onMouseUp = () => {
        draggingRef.current = false;
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
        onDragEnd?.();
      };

      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    },
    [onMove, trackRef, onDragStart, onDragEnd]
  );

  return (
    <div
      className="absolute top-1/2 -translate-y-1/2 group"
      style={{ left: `${kf.time * PX_PER_SEC}px` }}
    >
      <div
        onMouseDown={handleMouseDown}
        onDoubleClick={(e) => {
          e.stopPropagation();
          setShowEasing((s) => !s);
        }}
        onContextMenu={(e) => {
          e.preventDefault();
          onDelete();
        }}
        title={`t=${kf.time}s · easing: ${kf.easing} · dobel klik: easing, klik kanan: hapus`}
        className="w-3 h-3 bg-[#2F8F6F] rotate-45 border border-[#D7C7A1] cursor-grab active:cursor-grabbing hover:scale-125 transition-transform"
      />
      {showEasing && (
        <EasingPicker
          value={kf.easing}
          onChange={onEasingChange}
          onClose={() => setShowEasing(false)}
        />
      )}
    </div>
  );
}

export { PX_PER_SEC };
